import { AudioEngine } from '~/lib/audio-engine.js'

// One AudioContext for the whole app — created lazily on first use (always
// from a user-gesture-triggered call path: choosing a project / clicking
// play), never at module load time.
let engine: AudioEngine | null = null

export function useAudioEngine(): AudioEngine {
  if (!engine) {
    engine = new AudioEngine()
  }
  return engine
}

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    try {
      engine?.reset()
      engine?.ctx?.close?.()
    } catch {
      /* dev-server teardown only */
    }
    engine = null
  })
}
